import APP_ACTIONS from '../constants/app-actions';

const Taxons = {
    addTaxons: (taxons) => ({
        type: APP_ACTIONS.ADD_TAXONS,
        payload: taxons,
    }),
};

export default Taxons;



/** WEBPACK FOOTER **
 ** ./src/actions/taxons.js
 **/